import { render, staticRenderFns } from "./liveAnimals.vue?vue&type=template&id=04129829&scoped=true&"
import script from "./liveAnimals.vue?vue&type=script&lang=js&"
export * from "./liveAnimals.vue?vue&type=script&lang=js&"
import style0 from "./liveAnimals.vue?vue&type=style&index=0&id=04129829&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04129829",
  null
  
)

export default component.exports